// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import eventStatusEntity from './entities/event-status.json';
import eventStatusMenu from '../pages/event-status/menu.json';
import eventStatusFullForm from '../pages/event-status/forms/full.json';
import eventStatusContextForm from '../pages/event-status/forms/context.json';
import eventStatusMiniForm from '../pages/event-status/forms/mini.json';
import eventStatusLookupForm from '../pages/event-status/forms/lookup.json';
import eventStatusTableView from '../pages/event-status/views/table.json';
import eventStatusDashboardView from '../pages/event-status/views/dashboard.json';

/** Тип запису «Статус заходу» зі сторінками пакета: меню, форми та подання з pages/event-status/. */
export const eventStatusDefinition: IRecordTypeDefinition = {
  ...eventStatusEntity,
  views: assembleViewSet({
      table: eventStatusTableView,
      dashboard: eventStatusDashboardView,
  }),
  form: eventStatusFullForm,
  forms: { full: eventStatusFullForm, context: eventStatusContextForm, mini: eventStatusMiniForm, lookup: eventStatusLookupForm },
  menu: eventStatusMenu,
} as IRecordTypeDefinition;
